import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractService } from '@shared/abstract.service';
import { HttpClient } from '@angular/common/http';
import { SERVICES, HTTP_METHODS } from '@root/constant';
import { EncryptionProviderService } from '@shared/encryption.service';

const URL = SERVICES.USER_MANAGMENT.PATH;

@Injectable()
export class UserManagmentService extends AbstractService<any> {
  constructor(
    http: HttpClient,

    encryptionProviderService: EncryptionProviderService
  ) {
    super(http, URL, encryptionProviderService);
    this.encryptionProviderService = encryptionProviderService;
  }

  
  public createOrUpdateUser(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getActionUrlForUser(data),
      body: data,
    });
  }

  public getActionUrlForUser(data: any): string {
    let url = `${this.url}`;
    url = data.id ? `${url}/updateuser` : `${url}/reguser`;
    return url;
  }

  public readUsers(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/users`,
      body: data,
    });
  }

  public deleteUsers(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteuser`,
      body: data,
    });
  }

  public blockUsers(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/blockuser`,
      body: data,
    });
  }

  public readAccessList(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/accesslist`,
      body: data,
    });
  }

  /* Roles Sections */

  public getRoleList(data:any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/rolelist`,
      body:data,
    });
  }
  
  public deleteRole(data:any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleterole`,
      body:data,
    });
  }

  public createOrUpdateRole(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getActionUrl(data),
      body: data,
    });
  }

  public getActionUrl(data: any): string {
    let url = `${this.url}`;
    url = data.id ? `${url}/updaterole` : `${url}/addrole`;
    return url;
  }

  /**
   * AREA SECTION¯
   */

  public createOrUpdateRegion(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getActionUrlForRegion(data),
      body: data,
    });
  }

  public getActionUrlForRegion(data: any): string {
    let url = `${this.url}`;
    url = data.id ? `${url}/updateregion` : `${url}/addregion`;
    return url;
  }

  public getRegionList(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/regionlist`,
    });
  }

  public createOrUpdateDepartment(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: this.getActionUrlForDepartment(data),
      body: data,
    });
  }

  public getActionUrlForDepartment(data: any): string {
    let url = `${this.url}`;
    url = data.departmentId ? `${url}/updatedepartment` : `${url}/adddepartment`;
    return url;
  }

  public getDeparmentList(): Observable<any> {
    return this.request({
      method: HTTP_METHODS.GET,
      url: `${this.url}/getdepartments`,
    });
  }

  public deleteRegion(data:any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deleteregion`,
      body:data,
    });
  }

  public deleteDepartment(data:any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/deletedepartment`,
      body:data,
    });
  }

  public resetPassword(data: any): Observable<any> {
    return this.request({
      method: HTTP_METHODS.POST,
      url: `${this.url}/resetpassword`,
      body:data,
    });
  }


}
